( function () {
	'use strict';

	function multipleChoiceIndicator () {
		return {
			'templateUrl'      : '/templates/components/indicators/multiple-choice/multiple-choice.html',
			'restrict'         : 'E',
			'replace'          : true,
			'controller'       : 'MultipleChoice',
			'controllerAs'     : 'vm',
			'bindToController' : true,
			'scope'            : {
				'model'       : '=',
				'viewMode'    : '=',
				'readOnly'    : '=',
				'groupIndex'  : '=',
				'groupModel'  : '=',
				'index'       : '=',
				'flag'        : '=',
				'onObs'       : '=',
				'hideScoring' : '='
			}
		};
	}

	function runMultipleChoiceIndicator ( indicatorService ) {
		var mCConfigData = {
			'data' : {
				'title'         : 'Multiple Choice',
				'path'          : '/templates/components/indicators/multiple-choice/multiple-choice-init.html',
				'type'          : '2',
				'questionText'  : '<p>Untitled Multiple Choice</p>',
				'selectAll'     : true,
				'answerOptions' : [ {
					'optionText' : 'Option 1',
					'type'       : '2',
					'selectAll'  : true
				}, {
					'optionText' : 'Option 2',
					'type'       : '2',
					'selectAll'  : true
				} ]
			}
		};

		indicatorService.register( '2', mCConfigData );

		var nestedMCConfigData       = angular.copy( mCConfigData );

		nestedMCConfigData.isHidden  = true;
		nestedMCConfigData.data.type = 3;
		indicatorService.register( '3', angular.copy( nestedMCConfigData ) );
	}

	angular
		.module( 'app.components' )
		.run( runMultipleChoiceIndicator )
		.directive( 'multipleChoiceIndicator', multipleChoiceIndicator );

	runMultipleChoiceIndicator.$inject = [ 'indicatorService' ];
} )( );
